module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "pageiv",
      "title": "iv"
    }
  }), _c('a', {
    attrs: {
      "id": "pagev",
      "title": "v"
    }
  }, [_vm._v("Table of Contents")])]), _c('a', {
    attrs: {
      "id": "pagev",
      "title": "v"
    }
  }), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "pagev",
      "title": "v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Author#Author"
    }
  }, [_vm._v("Author’s Note: Sources and Methods")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgments#Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction#Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#Chapter01"
    }
  }, [_vm._v("Part 1: United States Presidential Administrations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: United States Congress")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3: United States Military")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 4: Governors")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 5: City Founders and Mayors")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 6: Officers of Professional Societies")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 7: Higher Education")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 8: Native Americans, Philanthropists, Industrialists, and Others")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Appendix#Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Bibliography#Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Bonus#Bounus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BONUS EXCERPT:")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Bonus",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("From Arlington to Appomattox: Robert E. Lee Day by Day, 1861-1865,")]), _vm._v(" by Charles R. Knight")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0